import Chart from "react-apexcharts";
import { Skeleton } from "@mui/material";
import { DashCard } from "./DashCard";
import { colors, fontFamily } from "../../data/tokens";
import { MonthlySeries } from "./useDashboardData";

// Novos sócios cadastrados por mês (últimos 12 meses)
export function GrowthBarChart({ monthly }: { monthly: MonthlySeries | null }) {
  return (
    <DashCard title="Novos sócios por mês (últimos 12 meses)">
      {!monthly ? (
        <Skeleton variant="rounded" height={280} />
      ) : (
        <Chart
          type="bar"
          height={300}
          series={[{ name: "Novos sócios", data: monthly.values }]}
          options={{
            chart: { fontFamily, toolbar: { show: false } },
            colors: [colors.primary],
            plotOptions: { bar: { borderRadius: 4, columnWidth: "55%" } },
            dataLabels: { enabled: false },
            xaxis: { categories: monthly.labels },
            yaxis: { labels: { formatter: (v: number) => String(Math.round(v)) } },
            grid: { borderColor: colors.neutral200 },
            tooltip: {
              y: { formatter: (v: number) => v.toLocaleString("pt-BR") },
            },
          }}
        />
      )}
    </DashCard>
  );
}
